import { Box, styled } from '@planne-software/uni/mui/material';
import { Grid } from '@planne-software/uni/Grid';
import { uni } from '@planne-software/uni/v2';

import { tabletBreakpoint } from '@src/common/utils/mediaQuery';

export const CardFormRoot = styled('form')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: uni('scale-400'),
  width: '100%',
}));

export const CARD_FIELD_SPACING = uni('scale-400');

export const CardFormFields = styled(Grid)(() => ({
  width: '100%',
}));

/**
 * Half the row from `sm` up, the whole row below it; `full` always takes everything.
 * The breakpoints are the theme's, so `sm` is 600px.
 */
export const cardFieldSize = (span?: 'full') => (span === 'full' ? 12 : { xs: 12, sm: 6 });

export const CardFormActions = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'space-between',
  gap: uni('scale-400'),
  width: '100%',
  [tabletBreakpoint]: {
    flexDirection: 'column-reverse',
    alignItems: 'stretch',
  },
}));

export const SubmitWrapper = styled(Box)(() => ({
  display: 'flex',
  flexShrink: 0,
  [tabletBreakpoint]: {
    width: '100%',
    '& > button': {
      width: '100%',
    },
  },
}));
